/** Display-only: API keeps Buy/Sell; UI shows localized label. */
export function translateDirection(direction, t) {
  if (!direction) return direction ?? '';
  const d = String(direction).trim();
  if (d.toLowerCase() === 'buy') return t('common.buy');
  if (d.toLowerCase() === 'sell') return t('common.sell');
  return direction;
}
